import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Box } from "@mui/material";

import VideoFeed from "../../../common/VideoFeed";
import Logout from "../../../common/Logout";

import "./style.css";


const OnHold = (props) => {
    const token = localStorage.getItem("access-token");
    let launchDateLS = props.User?.user?.launchDate;
    let userDetails = JSON.parse(localStorage.getItem("indi-new-user-details"));
    const info = JSON.parse(localStorage.getItem(token));

    const navigate = useNavigate();

    let launchDate = moment(new Date(launchDateLS ? launchDateLS : "")).format("MMMM Do").split(" ");


    useEffect(() => {
        let ld = new Date(launchDateLS);
        let cd = new Date();

        if (cd >= ld) {
            navigate("/personal-info");
        }
    }, []);

    return (
        <>
            <Logout showLogo />
            <Box id="on-hold-area" className="auth-box" style={{ padding: "0 0 50px 0" }}>
                <div className="container flex-c">
                    {/* <img src="/assets/images/logo.png" alt="Indi" height={"40px"} /> */}
                    <div className="auth-form" style={{ margin: "0" }}>
                        <VideoFeed
                            video={{
                                video_id: 781942387,
                                video_url: "https://player.vimeo.com/video/781942387?h=8328bf178e",
                                duration_watched: 0
                            }}
                            withCCast={false}
                        />

                        <div className="description">
                            <Box>
                                <h3 style={{ marginTop: '40px', fontFamily: 'Josefin Sans', fontWeight: "bold" }}>COMPLETE!</h3>
                            </Box>
                            <Box sx={{ mt: { xs: '10px', md: '10px' } }}>
                                <p className="orange-text-message">YOUR LIVE DATE IS {launchDate[0].toUpperCase()} {launchDate[1]}</p>
                            </Box>
                            <Box>
                                <p className="indi-font-family e-text">Great job, {info ? info.first_name : userDetails.name.first}. Your account has been created. You will have access starting on {launchDate.join(" ")}</p>
                            </Box>

                            <Box>
                                <p className="indi-font-family e-text">Watch the video above to learn more about indi! </p>
                            </Box>

                            <h3 style={{ marginTop: '40px', fontFamily: 'Josefin Sans', fontWeight: "bold" }}>GET THE APP.</h3>

                            <div className="apple-google-app-links">
                                <a target="_blank" href="https://apps.apple.com/us/app/indi-get-moving/id6444163742">
                                    <img src="/assets/images/appstore.png" />
                                </a>

                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.indimoves.indi">
                                    <img src="/assets/images/googleplay.png" />
                                </a>
                            </div>


                        </div>
                    </div>
                </div>
            </Box>
        </>
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
})(OnHold);